<template>
    <div >
        <PrimeExpand />

        <AppHeader />


        <slot />
        <AppTabMenu/>

    </div>
</template>
